'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.Dependency = void 0;
var Dependency = /** @class */ (function () {
    function Dependency() {}
    Dependency.prototype.toString = function () {
        throw new Error('toString should return uniq constant');
    };
    return Dependency;
})();
exports.Dependency = Dependency;
